/******************************************************************************
 * 
 * Strauss Motion
 * 
 * Copyright (c) 2022 Robimo GmbH
 *
 * Authors: Daniel Martinek
 *
 *****************************************************************************/
import { ReactElement, useState } from 'react';
import styles from '../styles/dropdownbutton.module.scss'
 
interface DropdownButtonProps {
    children?: ReactElement | (ReactElement | boolean)[];
    containerColor?: string;
    centered?: boolean;
    downward?: boolean;
}
  
export function DropdownButton(props: DropdownButtonProps) {
    const [isExpanded, setIsExpanded] = useState(false);

    var additionalStyle = {'backgroundColor' : 'none'};
    if(props.containerColor) {
        additionalStyle['backgroundColor'] = `${props.containerColor}CC`
    }
    return (
        <div className={`dropdownbutton ${styles.dropdown} ${props.downward ? styles.dropdownDownward : ''} ${props.centered ? styles.dropdownCentered : ''}`} onClick={() => {setIsExpanded(!isExpanded)}}>
            <div className={`${styles.dropdownbutton} ${isExpanded ? styles.dropdownbuttonexpanded : ''}`}>
                <div className={styles.dots}></div>
            </div>
            {
                true &&
                <div className={`${styles.container} ${isExpanded ? styles.containerexpanded : ''}`} style={additionalStyle}>
                    {props.children}
                </div>
            }
        </div>
    );
};
 